// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"Contact__ContactData__4Tdf5","Input":"Contact__Input__21MeV"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/ContactData/Contact.css
// module id = 167
// module chunks = 0